<template>
  <div class="order-create">
    <b-tabs v-model="tabIndex">
      <b-tab title="Orders">
        <b-row>
          <b-col md="12">
            <b-form @submit.prevent="submitForm">
              <template #header>
                <span class="pull-left mt-2">Orders importeren</span>
              </template>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Bedrijf">
                    <b-form-select :options="companies" v-model="company_id" autocomplete="off" :disabled="saveButtonDisabled" />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="Importbestand">
                    <b-form-file v-model="file" :state="Boolean(file)" accept=".xls, .xlsx, .csv, .txt" placeholder="Kies of sleep een bestand..." drop-placeholder="Sleep het bestand..." :disabled="saveButtonDisabled" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <hr>
                  <b-button type="submit" class="pull-right" block variant="primary" :disabled="!file || saveButtonDisabled">
                    Importeren
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Resultaat">
        <b-row v-if="errors">
          <b-col cols="12">
            <b-alert show variant="danger">
              Het gebruikte bestand is niet geldig. Er is/zijn {{ Object.keys(errors).length }} foutieve rij(en) gevonden.
            </b-alert>
            <table class="table table-striped import-table">
              <thead>
                <tr>
                  <th>Rij</th>
                  <th>Foutmeldingen</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(messages, row) in errors" :key="'error-row-' + row">
                  <td>{{ row }}</td>
                  <td>
                    <ul>
                      <li v-for="(message, index) in messages" :key="`error-row-${row}-message-${index}`" v-html="message"></li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import { getData, uploadData } from "../../api";

export default {
  name: 'order-import',
  data() {
    return {
      saveButtonDisabled: false,
      companies: [],
      company_id: undefined,
      file: null,
      errors: false,
      tabIndex: 0,
    }
  },
  methods: {
    async submitForm() {
      this.errors = false;
      this.saveButtonDisabled = true;

      let data = new FormData();
      data.append('file', this.file);
      data.append('company_id', this.company_id);

      uploadData('orders/import', data)
        .then(({ status, data }) => {
          this.saveButtonDisabled = false;

          if (status === 422) {
            this.errors = data.errors;
            this.tabIndex++;
          } else if (status === 200) {
            this.company_id = undefined;
            this.file = undefined;

            this.$bvToast.toast(`${data.order_count} order(s) toegevoegd`, {
              title: 'Import succes',
              autoHideDelay: 5000,
              variant: 'success',
            });
            localStorage.removeItem('orders-filters');
            this.$emit('callback');
          } else {
            this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren: ${data.message}`, {
              title: 'Oeps...',
              autoHideDelay: 5000,
              variant: 'danger',
            });
          }
        });
    },
    async getCompanies() {
      getData('companies/options').then(({ data }) => this.companies = data.data);
    },
  },
  beforeMount() {
    this.getCompanies();
  },
}

</script>
